// theming/ThemeCardMenu.jsx
import React from 'react';
import { EllipsisVertical } from 'lucide-react';
import { Button } from '@/dashboard/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/dashboard/components/ui/dropdown-menu';

/**
 * Per-card actions popover. Stops click propagation so opening the menu (or
 * choosing an item) never triggers the card's apply-on-click.
 */
export function ThemeCardMenu({
  isDefault,
  canDelete,
  iconColor,
  onSetDefault,
  onDuplicate,
  onDelete,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-xs"
          aria-label="Theme actions"
          className="bg-transparent hover:bg-transparent aria-expanded:bg-transparent focus-visible:border-transparent focus-visible:ring-0"
          style={iconColor ? { color: iconColor } : undefined}
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
        >
          <EllipsisVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        onClick={e => e.stopPropagation()}
        onCloseAutoFocus={e => e.preventDefault()}
      >
        <DropdownMenuItem
          disabled={isDefault}
          onSelect={() => {
            if (!isDefault) onSetDefault?.();
          }}
        >
          Set as default
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onDuplicate?.()}>Duplicate</DropdownMenuItem>
        {canDelete && (
          <DropdownMenuItem variant="destructive" onSelect={() => onDelete?.()}>
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ThemeCardMenu;
